import { SelectOptionProps } from '@innovationnorway/component-library';
import { Gender, TimeEntryStatus } from 'src/api/v2';

export const getGenderOptions = () => {
  const genderOptions: SelectOptionProps[] = [
    {
      value: Gender.Unspecified,
      text: 'Uspesifisert',
    },
    {
      value: Gender.Female,
      text: 'Kvinne',
    },
    {
      value: Gender.Male,
      text: 'Mann',
    },
  ];

  return genderOptions;
};

export const getTimeEntryStatusOptions = () => {
  const timeEntryStatusOptions: SelectOptionProps[] = [
    {
      value: TimeEntryStatus.Counting,
      text: 'Godkjent',
    },
    {
      value: TimeEntryStatus.PendingApproval,
      text: 'Trenger godkjenning',
    },
    {
      value: TimeEntryStatus.NonCounting,
      text: 'Ikke tellende',
    },
  ];

  return timeEntryStatusOptions;
};
